import { useTranslation } from 'react-i18next';

import { VStack, useVModal } from '@/package';
import { useReviewStore, useTaskFrameStore } from '@/store';

import { useReviewLabelInFrame } from './useFrame';

export const useVerfiyModal = ({
  frameSeq,
  taskId,
  onSuccess,
  onFail,
}: {
  frameSeq: Numberlish;
  taskId: Numberlish;

  onSuccess?: () => void;
  onFail?: () => void;
}) => {
  const { openConfirm } = useVModal();
  const { t } = useTranslation();
  const { currentFrame } = useTaskFrameStore();
  const { getCurrentPcdIndexReviewBoxList, comment } = useReviewStore();
  const reviewBoxList = getCurrentPcdIndexReviewBoxList();
  const { accept } = useReviewLabelInFrame({
    frameSeq: +frameSeq!,
    taskID: +taskId!,
  });

  const reviewAccept = async () => {
    try {
      await accept({
        reviewComment: comment,
        workData: currentFrame?.workData,
        reviewData: reviewBoxList,
      });

      onSuccess?.();
    } catch (err: any) {
      console.warn(err);
      onFail?.();
    }
  };

  const openVerifyModal = () => {
    openConfirm({
      size: 'small',
      title: t('frame.verify.artless'),
      message: () => (
        <VStack className="w-full" gap={0.25}>
          <div className="text-body-xl">
            {t('review.verifyCurrentFrame.pseudoaccidental')}
          </div>
          <div className="text-body-lg text-gray-600">
            {t('review.verfiyCurrentFrameDescription.damson')}
          </div>
        </VStack>
      ),
      cancelText: t('modal.cancelButtonText.intimidate'),
      confirmText: t('frame.verify.artless'),
      onConfirm: () => reviewAccept(),
    });
  };

  return { openVerifyModal };
};
